module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/wfft_3x.ee48c16.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/wfft_3x.png
// module id = cdQx
// module chunks = 41